import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('xeroAudit', 'xeroAudits');

const customActions = {
  async LOAD_xeroAuditsByDocument({ commit, rootGetters }, documentId) {
    const data = await odata.o(rootGetters)
      .get('xeroAudits')
      .query({ $filter: `expenseDocumentId eq ${documentId}` });
    commit('SET_xeroAudits', data);
  },
  async LOAD_xeroAudits({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('xeroAudits')
      .query({ $top: 10, $orderby: 'created desc' });
    commit('SET_xeroAudits', data);
  },
};
export default { ...actions, ...customActions };
